import { Box, Grid, Typography } from "@mui/material";
import * as React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { Translations } from "ui/Scripts/source/models/translations";
import { ILogListItem } from "../../../models/log/logListItem";
import { Dialog } from "../../framework/Dialog/Dialog";
import { DialogItemsNav } from "../../framework/Dialog/DialogItemsNav";
import { FormField } from "../../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/components/framework/FormField";
import { GridRow } from "../../framework/Grid/GridRow";
import { LongTextField } from "../../framework/LongTextField";
import { DialogButtons } from "source/components/framework/Dialog/DialogButtons";

export interface ILogDialogProp {
    classes?: string;
    item: ILogListItem
    hasPrevious: boolean;
    hasNext: boolean;
    onCancel: () => void;
    onPrevious: () => void;
    onNext: () => void;
}

export class LogDialog extends React.Component<ILogDialogProp, {}> {
    render() {
        const props = this.props;
        return (
            <Dialog
                maxWidth="lg"
                id="log-dialog"
                title={Translations.Log + ": " + Base.timeToDateTimeStr(props.item.modifyDate, true)}
                body={
                    <>
                        <GridRow>
                            <Grid item sm={4}>
                                <FormField title={Translations.Time}>
                                    <Typography>{Base.timeToDateTimeStr(props.item.modifyDate, true)}</Typography>
                                </FormField>
                            </Grid>
                            <Grid item sm={4}>
                                <FormField title={Translations.AType}>
                                    <Typography>{props.item.typeStr}</Typography>
                                </FormField>
                            </Grid>
                            <Grid item sm={4}>
                                <FormField title={Translations.Company}>
                                    <Typography>{props.item.companyCode}</Typography>
                                </FormField>
                            </Grid>
                        </GridRow>
                        <GridRow>
                            <Grid item sm={4}>
                                <FormField title={Translations.IpAddress}>
                                    <Typography>{props.item.callerIp}</Typography>
                                </FormField>
                            </Grid>
                            <Grid item sm={4}>
                                <FormField title={Translations.UserName}>
                                    <Typography>{props.item.userCode}</Typography>
                                </FormField>
                            </Grid>
                            <Grid item sm={4}>
                                <FormField title={Translations.Version}>
                                    <Typography>{props.item.version}</Typography>
                                </FormField>
                            </Grid>
                        </GridRow>
                        <GridRow>
                            <Grid item sm={4}>
                                <FormField title={Translations.Operation}>
                                    <Typography>{props.item.operation}</Typography>
                                </FormField>
                            </Grid>
                            <Grid item sm={8}>
                                <FormField title={Translations.Action}>
                                    <Typography>{props.item.action}</Typography>
                                </FormField>
                            </Grid>
                        </GridRow>
                        <GridRow>
                            <Grid item sm={12}>
                                <FormField title={Translations.BrowserInfo}>
                                    <Typography>{props.item.browserInfo}</Typography>
                                </FormField>
                            </Grid>
                        </GridRow>
                        <GridRow>
                            <Grid item sm={12}>
                                <FormField title={Translations.Parameters}>
                                    <LongTextField>{props.item.parameters}</LongTextField>
                                </FormField>
                            </Grid>
                        </GridRow>
                        <GridRow>
                            <Grid item sm={12}>
                                <FormField title={Translations.Message}>
                                    <LongTextField>{props.item.message}</LongTextField>
                                </FormField>
                            </Grid>
                        </GridRow>
                    </>
                }
                actions={
                    <Box display="flex" justifyContent="space-between" width="100%">
                        <DialogItemsNav
                            hasPrevious={props.hasPrevious}
                            hasNext={props.hasNext}
                            onPrevious={async () => props.onPrevious()}
                            onNext={async () => props.onNext()}
                        />
                        <DialogButtons
                            onCancel={props.onCancel}
                        />
                    </Box>
                }
                onClose={props.onCancel}/>
        );
    }
}